import { css } from 'styled-components';
import { minBreakpointQuery } from '.';

export const sectionMargins = () => {
  return css`
    margin: 40px 0;
    
    ${minBreakpointQuery.tiny`
      margin-top: 50px;
      margin-bottom: 50px;
    `}
    
    ${minBreakpointQuery.small`
      margin-top: 60px;
      margin-bottom: 60px;
    `}

    ${minBreakpointQuery.medium`
      margin-top: 70px;
      margin-bottom: 70px;
    `}

    ${minBreakpointQuery.large`
      margin-top: 80px;
      margin-bottom: 80px;
    `}

    ${minBreakpointQuery.xlarge`
      margin-top: 90px;
      margin-bottom: 90px;
    `}

    ${minBreakpointQuery.xxlarge`
      margin-top: 100px;
      margin-bottom: 100px;
    `}

    ${minBreakpointQuery.xxxlarge`
      margin-top: 110px;
      margin-bottom: 110px;
    `}

    ${minBreakpointQuery.xxxxlarge`
      margin-top: 120px;
      margin-bottom: 120px;
    `}
  `;
};
